import { Users, Activity, DollarSign, Settings, LogOut, BarChart2, AlertCircle, Scale, CircleDot, IndianRupee, AppWindow, QrCode, FileText, ShoppingBag, Bell, Menu, X, Clock, Gift, ArrowDownRight } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useState, useEffect, useContext } from 'react';
import { MoreHorizontal } from 'lucide-react';
import MembersTab from './Ownerdashboard/MembersTab';
import AttendanceTab from './Ownerdashboard/AttendanceTab';
import PaymentsTab from './Ownerdashboard/PaymentsTab';
import EquipmentTab from './Ownerdashboard/EquipmentTab';
import SettingsTab from './Ownerdashboard/SettingsTab';
import WeightTrackingTab from './Ownerdashboard/WeightTrackingTab';
import GymFeedManager from './Ownerdashboard/GymFeedManager';
import QRCodeContent from './dashboard/QRCodeContent';
import api from '../utils/api';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import EmployeesTab from './Ownerdashboard/EmployeesTab';
import ReportsTab from './Ownerdashboard/Reports';
import RedemptionOrders from './Ownerdashboard/RedemptionOrders';
import NotificationCenter from './dashboard/NotificationCenter';
import ExpensesTab from './Ownerdashboard/ExpensesTab';
import FreezeRequestsTab from './Ownerdashboard/FreezeRequestsTab';
import RenewalsDueTab from './Ownerdashboard/RenewalsDueTab';
import LiveCountTab from './Ownerdashboard/LiveCountTab';
import ActiveTodayTab from './Ownerdashboard/ActiveTodayTab';
import BirthdaysTab from './Ownerdashboard/BirthdaysTab';



const GymOwnerDashboard = ({ initialTab = 'Overview' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useContext(AuthContext);
  const [gymDetails, setGymDetails] = useState(null);
  const [checkInDetails, setcheckInDetails] = useState(null);
  //const [loading, setLoading] = useState(true);
  const stateTab = location.state?.activeTab;
  const [activeTab, setActiveTab] = useState(stateTab || initialTab);
  const [visitedTabs, setVisitedTabs] = useState(new Set([stateTab || initialTab]));
  const [notifOpen, setNotifOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleTabChange = (key, stateExtra = {}) => {
    setActiveTab(key);
    setVisitedTabs(prev => new Set(prev).add(key));
    if (key === 'Reports') {
      navigate('/owner/reports', { state: { activeTab: key, ...stateExtra } });
    } else {
      navigate('/Odashboard', { state: { activeTab: key, ...stateExtra } });
    }
  };
  const expiryDays = 7;
  const fitscan_user = JSON.parse(localStorage.getItem('fitscan_user'));

  const fetchGymDetails = async () => {
    try {
      const response = await api.post('/api/gym/dashboard', { identifier: fitscan_user.username, expiryDays });
      const data = response.data;
      setGymDetails(data);
      if (data && data.gymcode) {
        fetchcheckInDetails(data.gymcode);
      }
    } catch (error) {
      console.error("Error fetching gym details:", error);
    } finally {
      //setLoading(false);
    }
  };

  const fetchcheckInDetails = async (gymCodeParam) => {
    try {
      if (!gymCodeParam) return;
      const response = await api.post('/api/qrcode/getcheckindetails', { gymcode: gymCodeParam, timezoneOffsetMinutes: new Date().getTimezoneOffset() });
      const data = response.data;
      if (data) {
        setcheckInDetails(data);
      }

    } catch (error) {
      console.error("Error fetching CheckIn details:", error);
    } finally {
      //setLoading(false);
    }
  };






  useEffect(() => {
    if (fitscan_user && fitscan_user.username && fitscan_user.role === 'Owner') {
      fetchGymDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, fitscan_user?.username, expiryDays]);




  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    // Force a hard redirect to ensure the page fully reloads and auth is checked
    window.location.href = '/';
  };


  // Close menu when pressing Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setMobileMenuOpen(false);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);


  const gymData = {
    members: gymDetails?.totalActiveUsers ?? 0,
    activeToday: gymDetails?.activeToday ?? 0,
    livememberCount: gymDetails?.livememberCount ?? 0,
    checkInPercentage: gymDetails?.checkInPercentage ?? 0,
    newThisMonth: gymDetails?.newThisMonth ?? 0,
    revenue: gymDetails?.monthlyRevenue ?? 0,
    revenueGrowth: gymDetails?.revenueGrowth ?? 0,
    expiringSoonCount: gymDetails?.expiringSoonCount ?? 0,
    checkins: checkInDetails || [],
    todayCollection: gymDetails?.todayCollection ?? 0,
    liveMembershipsCount: gymDetails?.liveMembershipsCount ?? 0,
    expiring1To3Count: gymDetails?.expiring1To3Count ?? 0,
    expiring4To7Count: gymDetails?.expiring4To7Count ?? 0,
    expiring8To15Count: gymDetails?.expiring8To15Count ?? 0,
    totalOutgoing: gymDetails?.totalOutgoing ?? 0,
    birthdaysThisWeekCount: gymDetails?.birthdaysThisWeekCount ?? 0,
  };


  return (
    <div className="flex h-screen bg-[#101010] text-gray-200">

      {/* Desktop Sidebar */}
      <div className="w-64 bg-[#181818] border-r border-[#2b2b2b] p-4 hidden md:block">
        <div className="flex items-center gap-3 mb-8 p-2">
          <span className="bg-lime-400 rounded-xl p-2">
            <svg width="24" height="24" viewBox="0 0 448 512">
              <path d="M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z" fill="white" />
            </svg>
          </span>
          <span className="text-xl font-bold">FitScan</span>
        </div>

        <nav className="space-y-1">
          <button
            onClick={() => handleTabChange('Overview')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Overview' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <BarChart2 size={20} />
            <span>Overview</span>
          </button>
          <button
            onClick={() => handleTabChange('qrcode')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'qrcode' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <QrCode size={20} />
            <span>My QR Code</span>
          </button>


          <button
            onClick={() => handleTabChange('Management')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Management' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <Users size={20} />
            <span>Management</span>
          </button>

          <button
            onClick={() => handleTabChange('Attendance')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Attendance' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <Activity size={20} />
            <span>Attendance</span>
          </button>

          <button
            onClick={() => handleTabChange('FitnessTracking')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'FitnessTracking' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <Scale size={20} />
            <span>Fitness Tracking</span>
          </button>

          <button
            onClick={() => handleTabChange('Payments')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Payments' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <DollarSign size={20} />
            <span>Payments</span>
          </button>

          <button
            onClick={() => handleTabChange('Expenses')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Expenses' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <IndianRupee size={20} />
            <span>Expenses</span>
          </button>

          {gymDetails?.isFreezeEnabled && (
            <button
              onClick={() => handleTabChange('FreezeRequests')}
              className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'FreezeRequests' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
                }`}
            >
              <Clock size={20} />
              <span>Freeze Requests</span>
            </button>
          )}

          <button
            onClick={() => handleTabChange('Redemptions')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Redemptions' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <ShoppingBag size={20} />
            <span>Store Claims</span>
          </button>

          <button
            onClick={() => handleTabChange('employees')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'employees' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <Users size={20} />
            <span>Employees</span>
          </button>


          <button
            onClick={() => handleTabChange('Feed')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Feed' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <AppWindow size={20} />
            <span>Feed</span>
          </button>

          {/* <button
            onClick={() => handleTabChange('Equipment')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${
              activeTab === 'Equipment' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
            }`}
          >
            <Shield size={20} />
            <span>Equipment 🔒</span>
          </button> */}

          {/* <button
            onClick={() => handleTabChange('Access')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${
              activeTab === 'Access' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
            }`}
          >
            <QrCode size={20} />
            <span>Access Control 🔒</span>
          </button> */}

          <button
            onClick={() => handleTabChange('Reports')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Reports' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <FileText size={20} />
            <span>Reports</span>
          </button>

          <button
            onClick={() => handleTabChange('Profile')}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left ${activeTab === 'Profile' ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
              }`}
          >
            <Settings size={20} />
            <span>Settings</span>
          </button>

          <button
            onClick={() => handleLogout()}
            className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-left hover:bg-[#222] text-red-400 mt-4"
          >
            <LogOut size={20} />
            <span>Log Out</span>
          </button>
        </nav>
      </div>

      {/* Mobile Header */}
      <div className="md:hidden fixed top-0 left-0 right-0 bg-[#181818] border-b border-[#2b2b2b] flex justify-between items-center p-4 z-10">
        <div className="flex items-center gap-3">
          <span className="bg-lime-400 rounded-xl p-1">
            <svg width="20" height="20" viewBox="0 0 448 512">
              <path d="M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z" fill="white" />
            </svg>
          </span>
          <span className="font-bold">FitScan</span>
        </div>
        <div className="flex items-center gap-3">
          {/* Notification Bell */}
          <button
            className="relative p-2 rounded-full bg-[#222] border border-[#333] hover:border-lime-400/50 transition-all cursor-pointer"
            aria-label="Notifications"
            onClick={() => setNotifOpen(true)}
          >
            <Bell size={16} className="text-gray-400 hover:text-lime-400 transition-colors" />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 flex h-4 w-4">
                <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-[#6CD800]/40 opacity-75 blur-[2px]"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-[#6CD800] text-zinc-950 font-black text-[9px] items-center justify-center">
                  {unreadCount}
                </span>
              </span>
            )}
          </button>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-350 hover:text-white p-1.5 rounded bg-[#222] border border-[#333]"
          >
            {mobileMenuOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm"
          onClick={() => setMobileMenuOpen(false)}
        >
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
          <div className="absolute top-0 right-0 w-64 h-full bg-[#181818] border-l border-[#2b2b2b] p-4 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <nav className="space-y-1 mt-16">

              <div className="flex items-center gap-3 mb-8 p-2">
                <span className="bg-lime-400 rounded-xl p-2">
                  <svg width="24" height="24" viewBox="0 0 448 512">
                    <path d="M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z" fill="white" />
                  </svg>
                </span>
                <span className="text-xl font-bold">FitScan</span>
              </div>
              {[
                { id: 'Members', icon: <Users size={20} />, label: "Member" },
                { id: 'Attendance', icon: <Activity size={20} />, label: "Attendance" },
                { id: 'FitnessTracking', icon: <Scale size={20} />, label: "Fitness Tracking" },
                { id: 'Expenses', icon: <IndianRupee size={20} />, label: "Expenses" },
                ...(gymDetails?.isFreezeEnabled ? [{ id: 'FreezeRequests', icon: <Clock size={20} />, label: "Freeze Requests" }] : []),
                { id: 'Feed', icon: <AppWindow size={20} />, label: "Feed" },
                { id: 'employees', icon: <Users size={20} />, label: "Employees" },
                { id: 'Reports', icon: <FileText size={20} />, label: "Reports" },
                { id: 'Profile', icon: <Settings size={20} />, label: "Profile" }
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    handleTabChange(item.id);
                    setMobileMenuOpen(false);
                  }}
                  className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${activeTab === item.id ? 'bg-[#222] text-lime-400' : 'hover:bg-[#222]'
                    }`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              ))}

              <button
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
                className="flex items-center gap-3 w-full px-4 py-3 rounded-lg hover:bg-[#222] text-red-400 mt-4"
              >
                <LogOut size={20} />
                <span>Log Out</span>
              </button>
            </nav>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col h-full overflow-hidden pt-16 md:pt-0">
        {/* Desktop Header */}
        <header className="hidden md:flex h-16 items-center justify-between px-6 bg-[#181818] border-b border-[#2b2b2b] flex-shrink-0 z-10">
          <div className="flex items-center gap-2">
            <span className="text-gray-400 text-sm font-semibold">Owner Portal</span>
            {gymDetails?.name && (
              <span className="text-xs bg-[#222] text-[#6CD800] px-2.5 py-0.5 rounded-full font-bold border border-[#6CD800]/20">
                {gymDetails.name}
              </span>
            )}
          </div>
          <div className="flex items-center gap-4">
            {/* Notification Bell */}
            <button
              className="relative p-2.5 rounded-full bg-[#222] border border-[#333] hover:border-lime-400/50 transition-all group cursor-pointer"
              aria-label="Notifications"
              onClick={() => setNotifOpen(true)}
            >
              <Bell size={18} className="text-gray-400 group-hover:text-lime-400 transition-colors" />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-4 w-4">
                  <span className="animate-pulse absolute inline-flex h-full w-full rounded-full bg-[#6CD800]/40 opacity-75 blur-[2px]"></span>
                  <span className="relative inline-flex rounded-full h-4 w-4 bg-[#6CD800] text-zinc-950 font-bold text-[9px] items-center justify-center flex-shrink-0">
                    {unreadCount}
                  </span>
                </span>
              )}
            </button>
          </div>
        </header>

        {/* Scrollable Content Container */}
        <div className="flex-1 overflow-y-auto pb-28 md:pb-0">
          <div className="p-6">
            {/* Overview Tab */}


            {visitedTabs.has('Overview') && (
              <div className={`flex flex-col gap-4 ${activeTab === 'Overview' ? '' : 'hidden'}`}>
                {/* SECTION 1: Pulse Stats - 2x2 Grid */}
                <div className="grid grid-cols-2 gap-4">
                  {/* Total Members */}
                  <div
                    onClick={() => handleTabChange('Members', { activeFilter: 'all' })}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-blue-400">
                      <Users size={16} />
                      <span className="text-xs font-semibold text-gray-400">Total Memberships</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">{gymData.members}</p>
                      <p className="text-[10px] text-gray-500">{gymData.newThisMonth > 0 ? `+${gymData.newThisMonth}` : gymData.newThisMonth}% m-o-m</p>
                    </div>
                  </div>

                  {/* Live Memberships */}
                  <div
                    onClick={() => handleTabChange('Members', { activeFilter: 'active' })}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-lime-400">
                      <Users size={16} />
                      <span className="text-xs font-semibold text-gray-400">Live Memberships</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">{gymData.liveMembershipsCount}</p>
                      <span className="w-2 h-2 rounded-full bg-[#6CD800] animate-pulse" />
                    </div>
                  </div>

                  {/* Active Today */}
                  <div
                    onClick={() => handleTabChange('ActiveToday')}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-[#6cd800]">
                      <Activity size={16} />
                      <span className="text-xs font-semibold text-gray-400">Active Today</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">{gymData.activeToday}</p>
                      <p className="text-[10px] text-gray-500">{Number(gymData.checkInPercentage).toFixed(0)}% attendance</p>
                    </div>
                  </div>

                  {/* Live Count */}
                  <div
                    onClick={() => handleTabChange('LiveCount')}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-blue-400">
                      <CircleDot size={16} />
                      <span className="text-xs font-semibold text-gray-400">Live Count</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">{gymData.livememberCount}</p>
                      <span className="text-[9px] uppercase tracking-wider font-bold text-lime-400">Inside Gym</span>
                    </div>
                  </div>
                </div>

                {/* SECTION 2: Money - 2-column Row */}
                <div className="grid grid-cols-2 gap-4">
                  {/* Monthly Revenue */}
                  <div
                    onClick={() => handleTabChange('Payments', { dateFilter: 'month' })}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-emerald-400">
                      <IndianRupee size={16} />
                      <span className="text-xs font-semibold text-gray-400">Monthly Revenue</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">₹{gymData.revenue.toLocaleString()}</p>
                      <p className="text-[10px] text-emerald-400">{gymData.revenueGrowth > 0 ? `+${gymData.revenueGrowth}` : gymData.revenueGrowth}% growth</p>
                    </div>
                  </div>

                  {/* Today Collection */}
                  <div
                    onClick={() => handleTabChange('Payments', { dateFilter: 'today' })}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-emerald-400">
                      <IndianRupee size={16} />
                      <span className="text-xs font-semibold text-gray-400">Today Collection</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">₹{gymData.todayCollection.toLocaleString()}</p>
                      <span className="text-[9px] bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 px-2 py-0.5 rounded font-bold">TODAY</span>
                    </div>
                  </div>
                </div>

                {/* SECTION 3: Needs Your Attention */}
                {/* Membership Expiring 3-segment card */}
                <div className="bg-[#181818] border border-[#2b2b2b] rounded-xl p-4 space-y-3">
                  <div className="flex items-center gap-2 text-amber-500">
                    <AlertCircle size={16} />
                    <span className="text-xs font-semibold text-gray-400">Memberships Expiring</span>
                  </div>

                  <div className="grid grid-cols-3 gap-2">
                    <div
                      onClick={() => handleTabChange('RenewalsDue', { expirySegment: '1-3' })}
                      className="bg-red-500/10 hover:bg-red-500/20 border border-red-500/20 rounded-lg p-2.5 cursor-pointer text-center transition-all"
                    >
                      <span className="text-[10px] text-red-400 block font-semibold mb-1">1 - 3 Days</span>
                      <span className="text-xl font-bold text-white">{gymData.expiring1To3Count}</span>
                    </div>
                    <div
                      onClick={() => handleTabChange('RenewalsDue', { expirySegment: '4-7' })}
                      className="bg-amber-500/10 hover:bg-amber-500/20 border border-amber-500/20 rounded-lg p-2.5 cursor-pointer text-center transition-all"
                    >
                      <span className="text-[10px] text-amber-400 block font-semibold mb-1">4 - 7 Days</span>
                      <span className="text-xl font-bold text-white">{gymData.expiring4To7Count}</span>
                    </div>
                    <div
                      onClick={() => handleTabChange('RenewalsDue', { expirySegment: '8-15' })}
                      className="bg-emerald-500/10 hover:bg-emerald-500/20 border border-emerald-500/20 rounded-lg p-2.5 cursor-pointer text-center transition-all"
                    >
                      <span className="text-[10px] text-emerald-400 block font-semibold mb-1">8 - 15 Days</span>
                      <span className="text-xl font-bold text-white">{gymData.expiring8To15Count}</span>
                    </div>
                  </div>
                </div>

                {/* Total Outgoing and Birthdays Row */}
                <div className="grid grid-cols-2 gap-4">
                  {/* Total Outgoing */}
                  <div
                    onClick={() => handleTabChange('Expenses', { expenseFilter: 'this-month' })}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-red-400">
                      <ArrowDownRight size={16} />
                      <span className="text-xs font-semibold text-gray-400">Expense (This Month)</span>
                    </div>
                    <p className="text-2xl font-bold text-white mt-2">₹{gymData.totalOutgoing.toLocaleString()}</p>
                  </div>

                  {/* Birthdays */}
                  <div
                    onClick={() => handleTabChange('Birthdays')}
                    className="bg-[#181818] border border-[#2b2b2b] hover:border-lime-400/50 rounded-xl p-4 cursor-pointer transition-all hover:shadow-lg"
                  >
                    <div className="flex items-center gap-2 text-[#6cd800]">
                      <Gift size={16} />
                      <span className="text-xs font-semibold text-gray-400">Birthdays This Week</span>
                    </div>
                    <div className="flex justify-between items-baseline mt-2">
                      <p className="text-2xl font-bold text-white">{gymData.birthdaysThisWeekCount}</p>
                      <span className="text-[9px] bg-lime-500/10 text-lime-400 border border-lime-500/20 px-2 py-0.5 rounded font-bold">CELEBRATE</span>
                    </div>
                  </div>
                </div>

                {/* Peak Hours Chart */}
                <div className="bg-[#181818] border border-[#2b2b2b] rounded-xl p-4">
                  <h2 className="text-lg font-semibold mb-4 text-white">
                    Check-ins by Time Slot
                  </h2>
                  <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                      data={(gymData.checkins || []).filter(slot => slot.count > 0)}
                      barSize={Math.max(20, Math.min(60, Math.floor(300 / (((gymData.checkins || []).filter(slot => slot.count > 0)).length || 1))))}
                      barCategoryGap="30%"
                      margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
                    >
                      <CartesianGrid stroke="#2b2b2b" />
                      <XAxis
                        dataKey="hour"
                        stroke="#aaa"
                        tick={{ fontSize: 11 }}
                        padding={{ left: 20, right: 20 }}
                      />
                      <YAxis stroke="#aaa" allowDecimals={false} />
                      <Tooltip
                        contentStyle={{ backgroundColor: '#222', borderColor: '#2b2b2b', color: '#fff' }}
                      />
                      <Bar dataKey="count" fill="#84cc16" radius={[3, 3, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            )}

            {/* Members Tab */}
            {visitedTabs.has('Members') && (
              <div className={activeTab === 'Members' ? '' : 'hidden'}>
                <MembersTab onBack={() => setActiveTab('Overview')} />
              </div>
            )}

            {/* Management Tab */}
            {visitedTabs.has('Management') && (
              <div className={activeTab === 'Management' ? '' : 'hidden'}>
                <MembersTab />
              </div>
            )}

            {/* Renewals Due Tab */}
            {visitedTabs.has('RenewalsDue') && (
              <div className={activeTab === 'RenewalsDue' ? '' : 'hidden'}>
                <RenewalsDueTab
                  onBack={() => setActiveTab('Overview')}
                  initialSegment={location.state?.expirySegment || '1-3'}
                />
              </div>
            )}

            {/* Live Count Tab */}
            {visitedTabs.has('LiveCount') && (
              <div className={activeTab === 'LiveCount' ? '' : 'hidden'}>
                <LiveCountTab
                  onBack={() => setActiveTab('Overview')}
                  onViewDetails={() => {
                    handleTabChange('Attendance', { attendanceSubMode: 'live' });
                  }}
                />
              </div>
            )}

            {/* Active Today Tab */}
            {visitedTabs.has('ActiveToday') && (
              <div className={activeTab === 'ActiveToday' ? '' : 'hidden'}>
                <ActiveTodayTab onBack={() => setActiveTab('Overview')} />
              </div>
            )}

            {/* Birthdays Tab */}
            {visitedTabs.has('Birthdays') && (
              <div className={activeTab === 'Birthdays' ? '' : 'hidden'}>
                <BirthdaysTab onBack={() => setActiveTab('Overview')} />
              </div>
            )}

            {/* Attendence Tab */}
            {visitedTabs.has('qrcode') && (
              <div className={activeTab === 'qrcode' ? '' : 'hidden'}>

                <QRCodeContent />
              </div>
            )}


            {/* Attendence Tab */}
            {visitedTabs.has('Attendance') && (
              <div className={activeTab === 'Attendance' ? '' : 'hidden'}>

                <AttendanceTab />
              </div>
            )}


            {/* Attendence Tab */}
            {visitedTabs.has('FitnessTracking') && (
              <div className={activeTab === 'FitnessTracking' ? '' : 'hidden'}>

                <WeightTrackingTab />
              </div>
            )}

            {/* Payments Tab */}
            {visitedTabs.has('Payments') && (
              <div className={activeTab === 'Payments' ? '' : 'hidden'}>

                <PaymentsTab />
              </div>
            )}

            {/* Equipment Tab */}
            {visitedTabs.has('Equipment') && (
              <div className={activeTab === 'Equipment' ? '' : 'hidden'}>

                <EquipmentTab />
              </div>
            )}

            {/* AccessControl Tab */}
            {/* {activeTab === 'Access' && (
            <div>
              
              <AccessControlTab />
            </div>
          )} */}

            {/* Redemptions Tab */}
            {visitedTabs.has('Redemptions') && (
              <div className={activeTab === 'Redemptions' ? '' : 'hidden'}>
                <RedemptionOrders />
              </div>
            )}

            {visitedTabs.has('Feed') && (
              <div className={activeTab === 'Feed' ? '' : 'hidden'}>

                <GymFeedManager />
              </div>
            )}

            {/* Employees Tab */}
            {visitedTabs.has('employees') && (
              <div className={activeTab === 'employees' ? '' : 'hidden'}>

                <EmployeesTab />
              </div>
            )}

            {visitedTabs.has('Reports') && (
              <div className={activeTab === 'Reports' ? '' : 'hidden'}>
                <ReportsTab />
              </div>
            )}

            {visitedTabs.has('Expenses') && (
              <div className={activeTab === 'Expenses' ? '' : 'hidden'}>
                <ExpensesTab />
              </div>
            )}

            {visitedTabs.has('FreezeRequests') && (
              <div className={activeTab === 'FreezeRequests' ? '' : 'hidden'}>
                <FreezeRequestsTab />
              </div>
            )}

            {/* Setting Tab */}
            {visitedTabs.has('Profile') && (
              <div className={activeTab === 'Profile' ? '' : 'hidden'}>

                <SettingsTab />
              </div>
            )}


          </div>
        </div>
      </div>


      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-[#181818] border-t border-[#2b2b2b] flex justify-around p-2 z-10">
        {[
          { id: 'Overview', icon: <BarChart2 size={20} />, label: "Overview" },
          { id: 'Management', icon: <Users size={20} />, label: "Management" },
          { id: 'qrcode', icon: <QrCode size={20} />, label: "My QR Code", key: "qrcode" },
          { id: 'Payments', icon: <DollarSign size={20} />, label: "Payments" },

          // { id: 'FitnessTracking', icon: <Scale size={20} />, label: "Fitness Tracking" },
          {
            id: 'more',
            icon: <MoreHorizontal size={20} />,
            label: "More",
            isMenuTrigger: true
          }
        ].map((item) => (
          <button
            key={item.id}
            onClick={() => {
              if (item.isMenuTrigger) {
                setMobileMenuOpen(!mobileMenuOpen); // Toggle menu
              } else {
                handleTabChange(item.id);
                setMobileMenuOpen(false);
              }
            }}
            className={`flex flex-col items-center p-2 text-xs ${activeTab === item.id ? 'text-lime-400' : 'text-gray-400'
              } ${mobileMenuOpen && item.isMenuTrigger ? 'text-lime-400' : ''}`}
          >
            {item.icon}
            <span className="mt-1">{item.label}</span>
          </button>
        ))}
      </div>

      <NotificationCenter
        isOpen={notifOpen}
        onClose={() => setNotifOpen(false)}
        onNavigate={(menu) => {
          if (!menu) return;
          const lower = menu.toLowerCase();
          if (lower.includes('freeze')) {
            handleTabChange('FreezeRequests');
          } else if (lower.includes('redemption') || lower.includes('redeem')) {
            handleTabChange('Redemptions');
          } else if (lower.includes('expense')) {
            handleTabChange('Expenses');
          } else if (lower.includes('renewal')) {
            handleTabChange('RenewalsDue');
          } else if (lower.includes('birthday')) {
            handleTabChange('Birthdays');
          } else if (lower.includes('active')) {
            handleTabChange('ActiveToday');
          } else if (lower.includes('live')) {
            handleTabChange('LiveCount');
          } else if (lower.includes('member')) {
            handleTabChange('Members');
          } else if (lower.includes('attend')) {
            handleTabChange('Attendance');
          } else if (lower.includes('report')) {
            handleTabChange('Reports');
          } else if (lower.includes('profile') || lower.includes('setting')) {
            handleTabChange('Profile');
          } else {
            handleTabChange(menu);
          }
          setNotifOpen(false);
        }}
        username={fitscan_user?.username}
        onUnreadCountChange={setUnreadCount}
      />
    </div>
  );
};

export default GymOwnerDashboard;